import { OnInit, Directive, ElementRef, Input, HostListener, Renderer2, OnChanges } from '@angular/core';

/**
 * Define the CharCount Directive.
 */
@Directive({
  selector: '[appCharCount]'
})
/**
 * CharCount Class.
 */
export class CharCountDirective implements OnInit, OnChanges {
  @Input()
  appCharCount: number;

  @Input()
  location = 'below';

  @Input()
  align = 'left';

  eleNative;
  eleParentNative;
  divCounter;
  // Default character limit if none is supplied.
  private _defaultLimit = 200;
  // The character limit input variable.
  private _limit: number;

  // A html nativeElement (span) to display the character count.
  private _countDisplay: any;

  /**
   * Class constructor.
   *
   * @param { ElementRef } _elRef
   *   An ElementRef object instance.
   * @param { Renderer } _renderer
   *   A Renderer object instance.
   */
  constructor(private _elRef: ElementRef, private _renderer: Renderer2) {}

  ngOnChanges() {
    this.renderCounter();
  }
  /**
   * Handle keyup events from the host component.
   */
  @HostListener('keyup') private _onKeyUp() {
    // When the field on the host is updated. Update the count display.
    const count: any = this._elRef.nativeElement.value.length;

    // Clear the existing text and select the span as the root for the renderer
    this._renderer.selectRootElement(this._countDisplay);

    // Append a new text node to the span containing the current values
    this._renderer.appendChild(this._countDisplay, this._renderer.createText(this._elRef.nativeElement.value.length + '/' + this._limit));
  }

  /**
   * Implements the OnInit Angular2 lifecycle hook.
   */
  ngOnInit(): any {
    this.eleNative = this._elRef.nativeElement;
    this.eleParentNative = this.eleNative.parentElement;
    setTimeout(() =>{
      this.renderCounter();
    },0);
    
  }

  renderCounter() {
    if (this.eleNative) {
      this._renderer.selectRootElement(this.eleParentNative);

      // If no character limit was supplied via input, then use the default limit.
      this._limit = this.appCharCount || this._defaultLimit;

      if (this.divCounter) {
        this._renderer.removeChild(this.divCounter.parentElement, this.divCounter);
      }

      // Create the counter div
      const divCounter = this._renderer.createElement('div');
      this.divCounter = divCounter;
      const spanCounter = this._renderer.createElement('span');
      this._countDisplay = spanCounter;
      const textCounter = this._renderer.createText(this.eleNative.value.length + '/' + this._limit);

      this._renderer.appendChild(spanCounter, textCounter);
      this._renderer.appendChild(divCounter, spanCounter);

      // this._renderer.setStyle(divCounter, 'border', 'solid red 1px');
      // this._renderer.setStyle(spanCounter, 'border', 'solid red 1px');

      // Create the textarea div and add the original textarea to it
      const divTextArea = this._renderer.createElement('div');
      this._renderer.setAttribute(this.eleNative, 'maxlength', '' + this._limit);
      this._renderer.appendChild(divTextArea, this.eleNative);

      // Create the wrapper div and append the counter and textarea divs to it
      const divWrapper = this._renderer.createElement('div');

      switch (this.location) {
        case 'below':
        default:
          this._renderer.setStyle(divCounter, 'width', this.eleNative.style.width);
          this._renderer.appendChild(divWrapper, divTextArea);
          this._renderer.appendChild(divWrapper, divCounter);
          break;
        case 'above':
          this._renderer.setStyle(divCounter, 'width', this.eleNative.style.width);
          this._renderer.appendChild(divWrapper, divCounter);
          this._renderer.appendChild(divWrapper, divTextArea);
          break;
        case 'left':
          this._renderer.setStyle(divCounter, 'height', this.eleNative.style.height);
          this._renderer.setStyle(divCounter, 'float', 'left');
          this._renderer.appendChild(divWrapper, divCounter);
          this._renderer.appendChild(divWrapper, divTextArea);
          break;
        case 'right':
          this._renderer.setStyle(divCounter, 'height', this.eleNative.style.height);
          this._renderer.setStyle(divTextArea, 'float', 'left');
          this._renderer.appendChild(divWrapper, divTextArea);
          this._renderer.appendChild(divWrapper, divCounter);
          break;
      }

      switch (this.location) {
        case 'below':
        case 'above':
          switch (this.align) {
            case 'left':
            case 'right':
            case 'center':
              this._renderer.setStyle(divCounter, 'text-align', this.align);
              break;
            default:
              this._renderer.setStyle(divCounter, 'text-align', 'left');
          }
          break;
        case 'left':
        case 'right':
          switch (this.align) {
            case 'top':
            case 'bottom':
            case 'middle':
              this._renderer.setStyle(divCounter, 'line-height', this.eleNative.style.height);
              this._renderer.setStyle(spanCounter, 'margin-left', '3px');
              this._renderer.setStyle(spanCounter, 'margin-right', '3px');
              this._renderer.setStyle(spanCounter, 'display', 'inline-block');
              this._renderer.setStyle(spanCounter, 'vertical-align', this.align);
              this._renderer.setStyle(spanCounter, 'line-height', 'normal');
              break;
            default:
              this._renderer.setStyle(spanCounter, 'vertical-align', 'top');
              this._renderer.setStyle(spanCounter, 'margin-left', '3px');
              this._renderer.setStyle(spanCounter, 'margin-right', '3px');
          }
          break;
      }

      this._renderer.appendChild(this.eleParentNative, divWrapper);
    }
  }
}